export function average(arr: any[], fracionDigits?: number) {
  return arr.length > 0
    ? (arr.reduce((a, b) => a + b) / arr.length).toFixed(fracionDigits)
    : 0;
}
